export enum StatusMessageType {
    Success,
    Information,
    Warning,
    Error
}

export interface StatusMessageModel {
    type: StatusMessageType;
    code: string;
    message: string;
    autoClose: boolean;
    class: string;
    innerMessages: StatusMessageModel[];
}

export class StatusMessage {
    private statusMessage: StatusMessageModel;

    constructor(statusMessages: StatusMessageModel) {
        this.statusMessage = statusMessages
    }

    public getHTMLmessage(): string {
        let result: string;
        var container = this.getMainDivContainer(this.statusMessage);
        var closeButton = this.getCloseButton();
        container.appendChild(closeButton);
        var titleType = this.getTitleType(this.statusMessage.type);
        container.appendChild(titleType);
        var messageText = this.getMessage(this.statusMessage.message);
        container.appendChild(messageText);
        if (this.statusMessage.code) {
            var codeText = this.getMessage(`[${this.statusMessage.code}]`);
            container.appendChild(codeText);
        }
        if (this.statusMessage.innerMessages) {
            var innerMessages = this.getListElement(this.statusMessage.innerMessages);
            container.appendChild(innerMessages);
        }
        result = container.outerHTML;

        return result;
    }

    private getGeneratedGuid(): string {
        return 'xxxxxxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    private getListElement(innerMessages: StatusMessageModel[]) {
        var listElement = <HTMLUListElement>(document.createElement('ul'));
        innerMessages.forEach(item => {
            var itemElement = <HTMLLIElement>(document.createElement('li'));
            itemElement.appendChild(this.getMessage(item.message));
            listElement.appendChild(itemElement);
        });
        return listElement;
    }

    private getMessage(message: string): HTMLParagraphElement {
        var textElement = <HTMLParagraphElement>(document.createElement('p'));
        textElement.textContent = message;
        return textElement;
    }

    private getTitleType(type: StatusMessageType): HTMLHeadingElement {
        var heading = <HTMLHeadingElement>(document.createElement('h4'));
        heading.className = 'block';
        heading.textContent = StatusMessageType[type].toString();
        return heading;
    }

    private getCloseButton(): HTMLButtonElement {
        var button = <HTMLButtonElement>(document.createElement('button'));
        button.className = 'close';
        button.id = `closeStatusMessage${this.getGeneratedGuid()}`;
        button.type = 'button';
        button.setAttribute('data-dismiss', 'alert');
        button.setAttribute('aria-hidden', 'true');
        return button;
    }

    private getMainDivContainer(statusMessage: StatusMessageModel): HTMLDivElement {
        var container = <HTMLDivElement>(document.createElement('div'));
        container.className = `note note-${statusMessage.class}`;
        container.id = `statusMessage-${this.getGeneratedGuid()}`;
        container.setAttribute('data-componentType', 'statusMessage');
        container.setAttribute('data-autoClose', statusMessage.autoClose.toString().toLowerCase());
        return container;
    }
}



/** WEBPACK FOOTER **
 ** ./Typescript/Widgets/StatusMessage.ts
 **/